/*global REACT_APP_API_BASE_URL_NEW:true*/
import request from "@/utils/request";
import { buildDateCriteria, transformPropertyPaths } from "@/utils/utils";

export async function acceptPricingEnginePricingResult(shipmentId, quoteId, reason) {
  const data = {
    reason: reason || "",
    shipmentId,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/quote/accept/${quoteId}`, {
    method: "PATCH",
    data,
  });

  return result.data;
}

export async function adjustQuotesBulk(data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/quote/bulk`, {
    method: "PUT",
    data,
  });

  return result.data;
}

export async function adjustPriceQuotes(quoteId, data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/quote/adjust-price/${quoteId}`, {
    method: "PATCH",
    data,
  });

  return result.data;
}

export async function changeQuote(quoteId, data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/quote/${quoteId}`, {
    method: "PATCH",
    data,
  });

  return result.data;
}

export async function getQuotesByStatus({
  page = 1,
  pageSize = 10,
  filter = "",

  quoteStatus,

  sorting,
}) {
  page--;
  let Sorting;

  const customSortBy = {
    dealerPrice: "Quote.DealerPrice",
    dealerName: "Dealer.Name",
  };

  if (typeof sorting === "string" && sorting.indexOf(":") !== -1) {
    let [sortBy, sortOrder] = sorting.split(":");
    sortBy = customSortBy[sortBy] ?? sortBy;
    Sorting = `${sortBy} ${sortOrder}`;
  }

  const SkipCount = page * pageSize;

  const params = {
    SkipCount,
    MaxResultCount: pageSize,
    FilterText: filter || undefined,
    Sorting,

    Status: quoteStatus,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/shipments`, {
    method: "GET",
    params,
  });

  return result.data;
}

export async function getPayments({
  page = 1,
  pageSize = 10,
  filter = "",
  invoiceStatus,
  billStatus,
  createdAt,
  postedAt,
  pickedUpAt,
  droppedOffAt,
  pickedUpETA,
  droppedOffETA,
  dealerId,
  transporterId,
  sorting,
}) {
  page--;
  const SkipCount = page * pageSize;

  let Sorting;

  if (typeof sorting === "string" && sorting.indexOf(":") !== -1) {
    const [sortBy, sortOrder] = sorting.split(":");
    const sortByTransformed = transformPropertyPaths([sortBy], {
      "load.shipment.dealerName": "load.shipment.dealer.name",
    });
    Sorting = `${sortByTransformed} ${sortOrder}`;
  }

  const dateCriteria = buildDateCriteria(
    {
      ["load.shipment.creationTime"]: createdAt,
      ["load.shipment.postedAt"]: postedAt,
      ["load.shipment.pickedUpAt"]: pickedUpAt,
      ["load.shipment.droppedOffAt"]: droppedOffAt,
      ["load.shipment.pickupETA"]: pickedUpETA,
      ["load.shipment.dropOffETA"]: droppedOffETA,
    },
    "DateCriteria",
  );

  const dateParams = dateCriteria !== "" ? `?${dateCriteria}` : "";

  const params = {
    SkipCount,
    MaxResultCount: pageSize,
    FilterText: filter || undefined,
    InvoiceStatus: invoiceStatus,
    BillStatus: billStatus,
    DealerId: dealerId,
    TransporterId: transporterId,
    Sorting,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/payments${dateParams}`, {
    method: "GET",
    params,
  });

  return result.data;
}

export async function changeBillStatus(billId, params) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/payments/bill-status/${billId}`, {
    method: "PATCH",
    params,
  });

  if (result?.error) {
    throw new Error(result.error);
  }

  return result.data;
}

export async function changeInvoiceStatus(invoiceId, params) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/payments/invoice-status/${invoiceId}`, {
    method: "PATCH",
    params,
  });

  if (result?.error) {
    throw new Error(result.error);
  }

  return result.data;
}

export async function getPaymentById(paymentId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/payments/${paymentId}`, {
    method: "GET",
  });

  if (result?.error) {
    throw new Error(result.error);
  }

  return result.data;
}
